// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".optionWrapper--1_g4v9oh {\n  padding: 8px 20px;\n  font-weight: 400;\n  color: #999;\n  white-space: nowrap;\n  font-style: italic;\n}\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"optionWrapper": "optionWrapper--1_g4v9oh"
};
export default ___CSS_LOADER_EXPORT___;
